import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import OverviewTable from '../Filtering/OverviewTable/OverviewTable';

const BuildingSummaryOverviewTable = () => (
  <Form id="buildingOverviewForm" className="smallScreenReducePaddingOverview">
    <Grid stackable>
      <Grid.Row>
        <Grid.Column className="notPaddedSegment">
          <OverviewTable
            id="buildingSummaryTable"
            renderColumnSelector={false}
            renderSorting={false}
            renderSelection={false}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Form>
);

export default BuildingSummaryOverviewTable;
